import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import CatalogItems from './components/CatalogItems';
import { withRouter } from 'react-router-dom'
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux'
import Tour from './Tour'
import mockData from '../../../utils/mockData';
import TourNotActive from '../TourNotActive';

class TourCatalog extends Component {
  render () {
    let filterData = [];
    filterData = mockData.tourProducts();
    const { toggleTour } = this.props;
    return (
      <Container>
        {toggleTour.toggleOn ? <Container>
          <React.Fragment>
            <Tour/>
            <Row>
              <Col md={12}>
                <h3 className="page-title">{`Marketplace`} </h3>
              </Col>
            </Row>
            <Row>
              <CatalogItems catalog_items={filterData} />
            </Row>
          </React.Fragment>
        </Container > : <TourNotActive/> }
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    products: state.productsData ? state.productsData.products : null,
    sidebar: state.sidebar,
    toggleTour: state.toggleTour
  }
}

export default withRouter(withApollo(connect(mapStateToProps)(TourCatalog)));


// WEBPACK FOOTER //
// ./src/components/tour/e-commerce/TourCatalog.js